import { useEffect } from "react";
import { disposables as o } from "../utils/disposables.js";
import { useLatestValue as s } from "./use-latest-value.js";
function m(s$1, n, l) {
  let i = s((t) => {
    let e = t.getBoundingClientRect();
    e.x === 0 && e.y === 0 && e.width === 0 && e.height === 0 && l();
  });
  useEffect(() => {
    if (!s$1) return;
    let t = n === null ? null : n instanceof HTMLElement ? n : n.current;
    if (!t) return;
    let e = o();
    if (typeof ResizeObserver != "undefined") {
      let r = new ResizeObserver(() => i.current(t));
      r.observe(t), e.add(() => r.disconnect());
    }
    if (typeof IntersectionObserver != "undefined") {
      let r = new IntersectionObserver(() => i.current(t));
      r.observe(t), e.add(() => r.disconnect());
    }
    return () => e.dispose();
  }, [n, i, s$1]);
}
export {
  m as useOnDisappear
};
